import { SimpleSubathonWidget } from "@/Components/SimpleSubathonWidget/SimpleSubathonWidget";
import { useSocket } from "@/hooks/useSocket";
import { SubathonDocument, UpdateSubathonEvent } from "@ailenax-overlay/shared";
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const OBSSubathonWidget: FC = () => {
    const { id } = useParams();
    const socket = useSocket();
    const [subathon, setSubathon] = useState<SubathonDocument | null>(null);

    useEffect(() => {
        socket.emit("get-subathons", s => {
            const foo = s.find(bar => bar._id === id);
            if (foo) {
                setSubathon(foo);
            }
        });

        const onSubathonUpdate = (e: UpdateSubathonEvent) => {
            if (e.subathon._id === id) {
                setSubathon(e.subathon);
            }
        }

        socket.on("update-subathon", onSubathonUpdate);

        return () => {
            socket.off("update-subathon", onSubathonUpdate);
        }
    }, [id, socket]);

    if (!subathon) {
        return null;
    }

    return <SimpleSubathonWidget subathon={subathon} />;
}